module.exports = __webpack_public_path__ + "static/media/45b78f45-e639-4836-8612-e0892e120f14.26abda57.woff";